export default __webpack_public_path__ + "static/media/Aboutgraphics.324af560.png";